_   = require('underscore')
Vue = require('vue/dist/vue')

module.exports =
  namespaced: true

  state:
    environment:    null
    revision:       null
    session:        null

  getters:

    environment: (state, getters) ->
      state.environment

  mutations:

    _set: (state, config) ->
      _.each config, (value, key) =>
        Vue.set(state, key, value)

  actions:

    set: (context, config) ->
      context.commit('_set', config)



// WEBPACK FOOTER //
// ./assets/js/shared/store/settings/index.coffee